import { db } from "../firebase/config";
const updateField = async (doc, update, value) => {
    try {
        await db.doc(`users/${doc}`).update(update, value)
    } catch (err) {
        console.log(err.message);
    }
}
export default updateField